/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipForwardIcon16Regular = forwardRef('MediaUiASkipForwardIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.75 3a.75.75 0 0 0-1.5 0v4.668a1.336 1.336 0 0 0-.544-.78l-6.341-4.36A1.35 1.35 0 0 0 2.25 3.641v8.718a1.35 1.35 0 0 0 2.115 1.113l6.34-4.36c.288-.197.47-.477.545-.78V13a.75.75 0 0 0 1.5 0V3ZM9.676 8 3.75 12.074V3.926L9.676 8Z" })));
});
